// Compartidas entre el service worker (src/service-worker.js) y la app

// Caché de las respuestas GET del backend que se usan sin conexión
export const CACHE_API_DATOS = "api-datos";

// URL base del backend (misma lógica que src/config.js)
export const URL_API = process.env.REACT_APP_API_BASE_URL || "https://api.maderaselpaca.com/v1/";
